import { Component, Input, OnInit } from '@angular/core';
import { ModifiedActionStatus } from 'apps/website/src/app/utils/enums';

@Component({
  selector: 'intrasense-table-view-actions',
  templateUrl: './table-view-actions.component.html',
  styleUrls: ['./table-view-actions.component.scss']
})
export class TableViewActionsComponent implements OnInit {
  @Input('row') row: any;
  @Input('item') item: any;
  @Input('index') i: any;
  ModifiedActionStatus = ModifiedActionStatus;
  
  constructor() { }

  ngOnInit(): void {
  }

}
